import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import HelpIcon from "@mui/icons-material/Help";
import Modal from "@mui/material/Modal";
import * as React from "react";
import cryptoImage from '../crypto.png'

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function NavBar() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <Box sx={{ flexGrow: 1, width: '100%' }}>
      <AppBar position="static" color="secondary">
        <Toolbar>
          <img src={cryptoImage} alt="crypto-logo" style={{width : '2rem'}}/>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, marginLeft : '10px' }}>
            Crypto Trading Platform
          </Typography>
          <Button color="inherit" onClick={handleOpen}>
            <HelpIcon />
          </Button>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                What is this about?
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                This is a learning project to help new crypto investors to place
                fake trades using realtime prices and let them analyze their
                trades.
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                This tool is meant to help you have a hand inside crypto market without investing actual money
              </Typography>
            </Box>
          </Modal>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
